import React, { useState } from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function ContactForm() {
  const [formType, setFormType] = useState("distributor");
  const [selectedFile, setSelectedFile] = useState(null);
  const [contentRef, contentVisible] = useScrollAnimation();
  const [formRef, formVisible] = useScrollAnimation();
  const { t } = useTranslation();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file.name);
    } else {
      setSelectedFile(null);
    }
  };

  return (
    <div className="contactform-wrapper">
      <div className="contactform container flex bg-green">
        <div
          ref={contentRef}
          className={`contactform-content ${
            contentVisible ? "animate-in" : ""
          }`}
        >
          <h1 className="clr-white">
            <span className="clr-green">Let's Get</span> In Touch
          </h1>
          <p className="clr-white fs-500">
            {formType === "distributor"
              ? t("contactForm.distributorDesc")
              : t("contactForm.customerDesc")}
          </p>
          <div className="bg-white flex contactform-buttons">
            <div
              className={`contactform-buttons-slider ${
                formType === "customer" ? "slide-right" : ""
              }`}
            ></div>
            <button
              className={`fs-500 transition pointer ${
                formType === "distributor" ? "clr-white" : "clr-green"
              }`}
              onClick={() => setFormType("distributor")}
            >
              {t("contactForm.distributor")}
            </button>
            <button
              className={`fs-500 transition pointer ${
                formType === "customer" ? "clr-white" : "clr-green"
              }`}
              onClick={() => setFormType("customer")}
            >
              {t("contactForm.customer")}
            </button>
          </div>
        </div>
        <div
          ref={formRef}
          className={`contactform-form clr-white flex ${
            formVisible ? "animate-in" : ""
          }`}
        >
          <div className="flex">
            <input type="text" placeholder={t("contactForm.name")} />
            <input type="text" placeholder={t("contactForm.surname")} />
          </div>
          <div className="flex">
            <input type="email" placeholder={t("contactForm.email")} />
            <input type="number" placeholder={t("contactForm.phoneNumber")} />
          </div>
          <textarea placeholder={t("contactForm.message")}></textarea>
          <div className="file-upload-wrapper">
            <label htmlFor="file-upload" className="file-upload-label">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M14.1667 6.66667L10 2.5M10 2.5L5.83333 6.66667M10 2.5V12.5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>{t("contactForm.uploadFile")}</span>
            </label>
            <input
              type="file"
              id="file-upload"
              className="file-upload-input"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              onChange={handleFileChange}
            />
            <span className="file-upload-name">
              {selectedFile || t("contactForm.noFileChosen")}
            </span>
          </div>
          <button type="submit" className="clr-green transition pointer">
            {t("contactForm.submitForm")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
